import { sendEvent } from "./sender";
import { SegmentEventData } from "./events";

const PAGE_AUTHN_RECOMMENDATIONS = "authn_recommendations";
const CATEGORY_USER_ENGAGEMENT = "user-engagement";

type RecommendedProductClickedPayload = {
  position: number;
  recommendation_type: string;
  product_key: string;
  product_line: string;
  product_source: string;
  user_id: number | string;
} & SegmentEventData;

type RecommendationsViewedPayload = {
  recommendation_type: string;
  products: Array<{
    product_key: string;
    product_line: string;
    product_source: string;
  }>;
  user_id: number | string;
} & SegmentEventData;

type RecommendationsSkipBtnClickedPayload = {
  user_id: number | string;
} & SegmentEventData;

type WelcomePageSubmitClickedPayload = {
  isGenderSelected: boolean;
  isYearOfBirthSelected: boolean;
  isLevelOfEducationSelected: boolean;
  isWorkExperienceSelected: boolean;
  host: string;
} & SegmentEventData;

type WelcomePageSkipLinkClickedPayload = {
  host: string;
} & SegmentEventData;

type UserRecommendationsNotEnabledPayload = {
  functionalCookiesConsent: boolean;
} & SegmentEventData;

// Functions remain exported
export const sendRecommendedProductClicked = (
  payload: RecommendedProductClickedPayload,
) => {
  sendEvent("edx.bi.user.recommended.product.clicked", {
    page: PAGE_AUTHN_RECOMMENDATIONS,
    ...payload,
  });
};

export const sendRecommendationsViewed = (
  payload: RecommendationsViewedPayload,
) => {
  sendEvent("edx.bi.user.recommendations.viewed", {
    page: PAGE_AUTHN_RECOMMENDATIONS,
    ...payload,
  });
};

export const sendRecommendationsSkipBtnClicked = (
  payload: RecommendationsSkipBtnClickedPayload,
) => {
  sendEvent("edx.bi.user.recommendations.skip.btn.clicked", {
    page: PAGE_AUTHN_RECOMMENDATIONS,
    ...payload,
  });
};

export const sendWelcomePageSubmitClicked = (
  payload: WelcomePageSubmitClickedPayload,
) => {
  sendEvent("edx.bi.welcome.page.submit.clicked", { ...payload });
};

export const sendWelcomePageSkipLinkClicked = (
  payload: WelcomePageSkipLinkClickedPayload,
) => {
  sendEvent("edx.bi.welcome.page.skip.link.clicked", { ...payload });
};

export const sendWelcomePageSupportLinkClicked = () => {
  sendEvent("edx.bi.welcome.page.support.link.clicked");
};

export const sendUserRecommendationsNotEnabled = (
  payload: UserRecommendationsNotEnabledPayload,
) => {
  sendEvent("edx.bi.user.recommendations.not.enabled", {
    page: PAGE_AUTHN_RECOMMENDATIONS,
    ...payload,
  });
};

export const sendPasswordResetFormViewed = () => {
  sendEvent("edx.bi.password_reset_form.viewed", {
    category: CATEGORY_USER_ENGAGEMENT,
  });
};

export const sendInstitutionLoginFormToggled = () => {
  sendEvent("edx.bi.institution_login_form.toggled", {
    category: CATEGORY_USER_ENGAGEMENT,
  });
};

export const sendLoginFormToggled = () => {
  sendEvent("edx.bi.login_form.toggled", {
    category: CATEGORY_USER_ENGAGEMENT,
  });
};

export const sendRegisterFormToggled = () => {
  sendEvent("edx.bi.register_form.toggled", {
    category: CATEGORY_USER_ENGAGEMENT,
  });
};

export const sendUserAccountRegisteredClient = () => {
  sendEvent("edx.bi.user.account.registered.client", {});
};

export const sendPasswordResetFormToggled = () => {
  sendEvent("edx.bi.password-reset_form.toggled", {
    category: CATEGORY_USER_ENGAGEMENT,
  });
};

export const sendUserAccountAuthenticatedClient = () => {
  sendEvent("edx.bi.user.account.authenticated.client", {});
};

export const sendUserPasswordResetSuccess = () => {
  sendEvent("edx.bi.user.password.reset.success", {});
};
